import React from "react";
import 'index.scss';
import 'rodal/lib/rodal.css';
import PropTypes from "prop-types";
import icClose from 'static/ic-close.png';
import bgRodal from 'static/bg-rodal.png';
import unExpected from 'static/un_expected.png';
import Rodal from 'rodal';
import styled from "styled-components";
import { getGameAsset } from 'helpers/gameAssets';

const CloseButton = styled.img`
    margin-top:19.11px;
    margin-right: 15.83px;
    z-index: 9999;
`
const styles = {
    backgroundImage: `url(${bgRodal})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    backgroundPosition: "center",
    textAlign: 'center',
    padding: 0,
    borderRadius: "1.5rem"
}

const Message = styled.p`
    padding-left: 1.75rem;
    padding-right: 1.75rem;
    margin-bottom: 1.875rem;
    white-space: pre-wrap;
`
const LinearButton = styled.p`
    margin: 0 auto;
    min-width: 112px;
    max-height: 30px;
    padding-top: 5px;
    padding-bottom: 5px;
`

const ModalUnexpectedNew = ({ isOpen, message, btnLabel, onCloseModal, gameCode }) => {
    const modalStyles = {
        ...styles,
        backgroundImage: `url(${getGameAsset(gameCode, 'bg-rodal', bgRodal)})`,
    };

    return (
        <div>
            <Rodal className="rodal justify-content-center" visible={isOpen} onClose={() => onCloseModal()} showCloseButton={false} closeMaskOnClick={false} customStyles={modalStyles}>
                <div className="d-flex justify-content-end align-items-center">
                    <CloseButton className="icon-header" src={icClose} onClick={() => onCloseModal()} />
                </div>
                <div className="absolute top-[31.79px] mx-0 left-0 right-0">
                    <img className="align-center" src={unExpected} alt="sad" style={{ mixBlendMode: "luminosity", maxWidth: "25%" }} />
                    <Message>{message || "Đã có lỗi xảy ra"}</Message>
                    <LinearButton className="linear-button" onClick={() => onCloseModal()}>{btnLabel || "ĐÓNG"}</LinearButton>
                </div>

            </Rodal>
        </div>
    )
}


ModalUnexpectedNew.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    message: PropTypes.string,
    buttonLabel: PropTypes.string,
    onCloseModal: PropTypes.func.isRequired,
};

export default ModalUnexpectedNew;